<template>
    <div class="ls-flow--container">
        <LsTemplatedLoading :show="loading" :full-screen="true" test-id="loading" />
        <div class="ls-flow--title">Conversation View</div>
        <div v-if="!loading && messages.length">
            <LsMessage
                v-for="message in messages"
                :key="message.id"
                :message="message"
                :customer="customer"
                :contractor="contractor"
                :update-schedule-conversation-message="updateScheduleConversationMessage"
            />
        </div>
        <LsContentPlaceholder
            v-if="!loading && !messages.length"
            fit-to-parent
            message="No messages sent"
            image="search"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import { lsErrorService } from 'ls-vue-common';
import { lsHelpers } from '@/helpers';
import LsContentPlaceholder from '@/components/LsContentPlaceholder/LsContentPlaceholder.vue';
import LsTemplatedLoading from '@/components/LsTemplatedLoading/LsTemplatedLoading.vue';
import ScheduleConversation from '@/graphql/queries/ScheduleConversation.gql';
import UpdateScheduleConversationMessage from '@/graphql/mutations/UpdateScheduleConversationMessage.gql';
import LsMessage from '@/views/Authorized/ConversationView/components/LsMessage/LsMessage.vue';

export default {
    name: 'ConversationView',
    components: {
        LsMessage,
        LsTemplatedLoading,
        LsContentPlaceholder,
    },
    data() {
        return {
            loading: 0,
            isUpdating: false,
            conversation_id: '',
            messages: [],
            contractor: {},
            customer: {},
        };
    },
    apollo: {
        scheduleConversation: {
            query: ScheduleConversation,
            variables() {
                return {
                    customer_id: _.toNumber(this.$route.params.customer_id),
                    property_id: _.toNumber(this.$route.params.property_id),
                    schedule_id: _.toNumber(this.$route.params.schedule_id),
                };
            },
            result({ data, loading }) {
                if (!loading && data && data.scheduleConversation) {
                    this.conversation_id = data.scheduleConversation.id;
                    this.messages = data.scheduleConversation.messages;
                    this.contractor = data.scheduleConversation.contractor;
                    this.customer = data.scheduleConversation.customer;
                }
            },
            error(error) {
                lsErrorService.log({ error, showAlert: true });
                lsHelpers.goToParentView({ replace: true });
            },
            loadingKey: 'loading',
        },
    },
    methods: {
        async updateScheduleConversationMessage(messageId, changedStatus) {
            this.$apollo
                .mutate({
                    mutation: UpdateScheduleConversationMessage,
                    variables: {
                        conversation_id: _.toNumber(this.conversation_id),
                        message_id: _.toNumber(messageId),
                        status: changedStatus,
                    },
                })
                .catch((error) => {
                    lsErrorService.log({ error, showAlert: true });
                })
                .finally(() => {
                    this.isUpdating = false;
                });
        },
    },
};
</script>
